import { render, staticRenderFns } from "./activityRecord.vue?vue&type=template&id=e5935294&scoped=true"
import script from "./activityRecord.vue?vue&type=script&lang=js"
export * from "./activityRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5935294",
  null
  
)

export default component.exports